import { Button, Flex } from '@chakra-ui/react'
import InputFloating from '../../../components/InputFloating'

export function Filtros({
  handleSearchValue,
  register,
  handleSubmit,
  setValue,
}) {
  return (
    <Flex
      w="100%"
      gap={5}
      mb={3}
      justifyContent="space-between"
      as="form"
      onSubmit={handleSubmit(handleSearchValue)}
    >
      <InputFloating
        name="Nome Liberador"
        {...register('nome_liberador')}
        label="Nome Liberador"
      />
      <InputFloating
        name="Nome Usuário"
        {...register('nome_usuario')}
        label="Nome Usuário"
      />
      <InputFloating
        name="Data Início"
        {...register('data_inicio')}
        label="Data Início"
        type="date"
      />
      <InputFloating
        name="Data Fim"
        {...register('data_fim')}
        label="Data Fim"
        type="date"
      />

      <Button colorScheme="blue" type="submit" maxW="200px" w="100%">
        Pesquisar
      </Button>
    </Flex>
  )
}
